<wizard-labeled-field
    label="Meeting should occur sometime:"
    class="no-bottom-margin"
    size="auto"
    [isPaired]="true"
    [isSecondaryLabel]="true"
    [shouldHideTooltip]="true"
    [alwaysShowHeader]="true"
>
    <common-date-range
        [dateRange]="dateRange"
        [hideDateRangeOptions]="true"
        (onUpdateDateRange)="handleUpdateDateRange($event)"
        (onUpdateDateRangeMode)="handleUpdateDateRangeMode($event)"
    ></common-date-range>
</wizard-labeled-field>
